/* GetCreditsCostLabel.js */
/* @author: anghello */

import React from "react";
import PSO from "../services/PSO";
import Strings from "../translations/Translations";
import Badge1 from "../components/misc/Badge1/Badge1";

export const getCreditsCostLabel = async (un, al, action, multiplier = null, secondAction = null) => {
  let label = '';
  if (un && al && action) {
    try {
      const response = await PSO.getTransactionsPrices({ un, al });
      if (response && response.result === 'success' && response.its) {
        const targetAction = response.its.filter((item) => item.feat === action)[0];
        if (targetAction) {
          let { price } = targetAction;
          if (action === 'createAiPhotoFast') {
            const photoAction = response.its.filter((item) => item.feat === 'createAiPhoto')[0];
            if (multiplier) {
              price = (photoAction.price * multiplier) + price;
            } else {
              price = price + photoAction.price;
            }
          } else if (action === 'createRemix' && secondAction) {
            const transactionPrices = response.its;
            if (secondAction === 'createAiClip') {
              const action = transactionPrices.filter((item) => item.feat === secondAction)[0];
              price += action.price;
            } else if (secondAction === 'createAiPhoto') {
              const action = transactionPrices.filter((item) => item.feat === secondAction)[0];
              if (multiplier) { price = (action.price * multiplier) + price; }
              else { price = price + action.price; }
            } else if (secondAction === 'createAiPhotoFast') {
              const actionFast = transactionPrices.filter((item) => item.feat === secondAction)[0];
              const actionPhoto = transactionPrices.filter((item) => item.feat === 'createAiPhoto')[0];
              if (multiplier) { price += (actionPhoto.price * multiplier) + actionFast.price; }
              else { price += actionPhoto.price + actionFast.price; }
            }
          } else if (multiplier) {
            price = price * multiplier;
          }

          return <Badge1>{price} {Strings('credits')}</Badge1>;
        }
      }
    } catch (err) {
      console.error('Error on [PSO.getTransactionsPrices]');
    }
  }
  return label;
}
